import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { VehicleCardContext } from '../../../../configs/vehicle-card-view/state.manager'
import formatNumber from './../../../../utils/format-number.utils'

import SpecsItem from './spec-item/SpecsItem'

const VehicleSpecs = ({ isHumberview, extraClasses }) => {
    const {
        state: {
            vehicle: { driveTrainDetails, fuel, transmissionDetails, odometer, newVehicle },
        },
    } = React.useContext(VehicleCardContext)

    const baseClass = 'vc-vehicleSpecs'
    const classNames = clsx(baseClass, extraClasses)

    if (!driveTrainDetails?.slug && !fuel?.name && !transmissionDetails?.name) {
        return null
    }

    return (
        <div className={classNames}>
            {driveTrainDetails?.slug && (
                <SpecsItem
                    extraClasses={`${baseClass}__item`}
                    label={driveTrainDetails?.slug.toUpperCase()}
                    icon='icon-specs-drivetrain'
                />
            )}

            {fuel?.name && <SpecsItem extraClasses={`${baseClass}__item`} label={fuel?.name} icon='icon-specs-fuel-type' />}

            {isHumberview && transmissionDetails?.name && (
                <SpecsItem extraClasses={`${baseClass}__item`} label={transmissionDetails?.name} icon='icon-specs-automatic' />
            )}

            {!newVehicle && odometer && (
                <SpecsItem
                    extraClasses={`${baseClass}__item`}
                    label={formatNumber(odometer, 'kilometer')}
                    icon='icon-specs-mileage'
                />
            )}
        </div>
    )
}

VehicleSpecs.propTypes = {
    /** Flag for Humberview Group */
    isHumberview: PropTypes.bool,
    /** Extra Classes */
    extraClasses: PropTypes.string,
}

VehicleSpecs.defaultProps = {
    isHumberview: true,
    extraClasses: '',
}

export default VehicleSpecs
